<template>
	<div>
		<el-dialog :close-on-click-modal="false" title="權限管理" :visible.sync="dialogVisible" width="30%"
			:before-close="handleClose">
			<div>
				<el-tree ref="tree" :check-strictly="checkStrictly" :data="data" node-key="id" default-expand-all
					highlight-current :default-expanded-keys="expandedRoles" :default-checked-keys="expandedRoles"
					:props="defaultProps" show-checkbox />
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: {
			dialogVisible: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				checkStrictly: true,
				expandedRoles: [], // 默认展开的节点的 key 的数组
				checkStrictly: true,
				data: [],
				hasIds: [],
				role: {},
				loading: true,
				defaultProps: {
					children: 'children',
					label: 'rule_name'
				}
			}
		},
		created() {

		},
		methods: {
			submit() {
				var checkedNodes = this.$refs.tree.getCheckedNodes()
				var checkedHalfNodes = this.$refs.tree.getHalfCheckedNodes()
				var Nodes = [...checkedNodes,...checkedHalfNodes]
				let menuIds = [];
				Nodes.forEach(nodes => {
					menuIds.push(nodes.id)
				})
				let keys = menuIds.filter(num => num !== 0);
				let Keys = [...new Set(keys)];
				this.$request({
					url: this.$api.role.setRules,
					method: "post",
					data: {
						ids: Keys,
						role_id: this.role.id
					}
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.$emit("close");
					} else {
						this.$message.error(res.data.msg);
					}
				}).catch(() => {
					this.$message.error('请求失败');
				})
			},
			handleClose() {
				this.$emit("close");
			},
			getAllRuleList() {
				this.$request({
					url: this.$api.rules.getAllRuleList,
				}).then((res) => {
					if(res.data.code==1){
						this.data = res.data.data;
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			getRoleRules(val) {
				this.$request({
					url: this.$api.rules.getRoleRules,
					data: {
						role_id: val.id
					}
				}).then((res) => {
					if(res.data.code==1){
						this.hasIds = res.data.data;
						this.expandedRoles = res.data.data;
						this.loading = false;
					}else{
						this.$message.error(res.data.msg)
					}
				})
			},
			getData(val) {
				this.checkStrictly = true; //不关联
				this.role = val;
				this.getAllRuleList();
				let columnValue = val.access.map(row => row.rule_id);
				// this.checkStrictly = true; //不要关联。checkStrictly = true   页面渲染完成，和用户交互时，我们希望关联。checkStrictly = false
				this.$nextTick(() => {
					setTimeout(() => {
						this.$refs.tree.setCheckedKeys(columnValue)
						this.checkStrictly = false; //关联
					}, 500);

				})
			},


		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/role/RoleSetRuleModal.vue